import RecordPickerController from './controllers/RecordPickerController';

// this is the entry point for rendering a record picker. See actionOpenSearchModal
export const sharedRecordPickerController = new RecordPickerController();

sharedRecordPickerController.internalInitialize(null, {});
